import React, { useState } from "react";

import LeftArrowIcon from "../icons/leftArrowIcon"

export default props => {
    const [styleIcon, setStyleIcon] = useState("account-button-back-icon");

    return (
        <div className={props.className} style={props.style} >
            <div className={"account-button-back"}
                onMouseOver={() => setStyleIcon("account-button-back-icon account-button-back-icon-hover ")}
                onMouseOut={() => setStyleIcon("account-button-back-icon")}
                onClick={props.onClick}>
                <span className={styleIcon} style={props.text ? "": {borderRadius: 50}}>
                    {props.children ? props.children : <LeftArrowIcon />}
                </span>
                <span className="account-button-back-text">{props.text}</span>
            </div>
        </div>
    )
}
